// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3BaXC","title":"ClientReferral_title__1mF13","itemText":"ClientReferral_itemText__1Dxk7"};